export default __webpack_public_path__ + "static/media/logo1.8a80863c.svg";